import React, { useState, useEffect } from 'react';
import { Card } from 'primereact/card';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Button } from 'primereact/button';
import { InputText } from 'primereact/inputtext';
import ConfirmModal from './modals/confirmx'; // Modal de confirmação (se necessário)
import FeedbackModal from './modals/FeedbackModal'; // Modal de feedback (loading, success, error)
import DarEntradaModal from './modals/entradamodal'; // Modal para dar entrada
import ImpEtiquetas from './modals/impetiquetas'; // Modal para imprimir etiquetas
import { Hourglass } from 'react-loader-spinner';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { getFinishedProducts, darEntrada, imprimirEtiquetas } from '../services/api';

const Entrada = () => {
  // Estado para os produtos (Finished Products)
  const [merchandises, setMerchandises] = useState([]);
  const [globalFilter, setGlobalFilter] = useState('');
  const [loading, setLoading] = useState(false);

  // Estados para as modais
  const [entradaModalVisible, setEntradaModalVisible] = useState(false); // Para dar entrada
  const [impEtiquetasVisible, setImpEtiquetasVisible] = useState(false); // Para imprimir etiquetas
  const [selectedProduct, setSelectedProduct] = useState(null);

  const [feedbackVisible, setFeedbackVisible] = useState(false);
  const [feedbackStatus, setFeedbackStatus] = useState(''); // 'loading', 'success', 'error'
  const [feedbackMessage, setFeedbackMessage] = useState('');

  // Supondo que você tenha uma lista de empregados para a impressão
  const [employees, setEmployees] = useState([]);

  // Carrega os produtos finalizados com stock
  useEffect(() => {
    const fetchProducts = async () => {
      setLoading(true);
      setFeedbackStatus('loading');
      setFeedbackMessage('Loading finished products...');
      setFeedbackVisible(true);
      try {
        const response = await getFinishedProducts();
        setMerchandises(response.data);
        setFeedbackStatus('success');
        setFeedbackMessage('Finished products loaded successfully!');
      } catch (error) {
        console.error('Error fetching finished products:', error);
        setFeedbackStatus('error');
        setFeedbackMessage('Error loading finished products.');
      }
      setLoading(false);
      setTimeout(() => {
        setFeedbackVisible(false);
      }, 1500);
    };

    fetchProducts();
  }, []);

  // Ao clicar em "Dar Entrada", abre a modal DarEntradaModal
  const handleDarEntrada = (product) => {
    setSelectedProduct(product);
    setEntradaModalVisible(true);
  };

  // Ao clicar em "Imprimir Etiquetas", abre a modal ImpEtiquetas
  const handleImprimirEtiquetas = (product) => {
    setSelectedProduct(product);
    setImpEtiquetasVisible(true);
  };

  const fetchProducts = async () => {
    setLoading(true);
    setFeedbackStatus('loading');
    setFeedbackMessage('Loading finished products...');
    setFeedbackVisible(true);
    try {
      const response = await getFinishedProducts();
      setMerchandises(response.data);
      setFeedbackStatus('success');
      setFeedbackMessage('Finished products loaded successfully!');
    } catch (error) {
      console.error('Error fetching finished products:', error);
      setFeedbackStatus('error');
      setFeedbackMessage('Error loading finished products.');
    }
    setLoading(false);
    setTimeout(() => {
      setFeedbackVisible(false);
    }, 1500);
  };

  // Callback para confirmar a entrada na modal DarEntradaModal
  const handleDarEntradaConfirm = async ({ numberOfBoxes, quantityPerBox, boxType, obs }) => {
    const user = JSON.parse(localStorage.getItem('user'));

    setEntradaModalVisible(false);
    setFeedbackStatus('loading');
    setFeedbackMessage('Processing stock entry...');
    setFeedbackVisible(true);

    try {
      await darEntrada(
        selectedProduct.id, 
        numberOfBoxes, 
        quantityPerBox,
        boxType,
        obs,
        user
      );

      setFeedbackStatus('success');
      setFeedbackMessage('Stock entry processed successfully!');
    } catch (error) {
      console.error('Error processing stock entry:', error);
      setFeedbackStatus('error');
      setFeedbackMessage('Error processing stock entry.');
    }

    setTimeout(() => {
      setFeedbackVisible(false);
    }, 1500);
  };

  // Callback para confirmar a impressão de etiquetas a partir do modal ImpEtiquetas
  const handlePrintLabels = async (data) => {
    // data contém: referencia, employeeId e numEtiquetas
    setImpEtiquetasVisible(false);
    setFeedbackStatus('loading');
    setFeedbackMessage('Processing label printing...');
    setFeedbackVisible(true);
    try {
      // Chame sua função imprimirEtiquetas passando o id do produto e os dados de impressão
      await imprimirEtiquetas(selectedProduct.id, data);
      setFeedbackStatus('success');
      setFeedbackMessage('Labels printed successfully!');
    } catch (error) {
      console.error('Error processing label printing:', error);
      setFeedbackStatus('error');
      setFeedbackMessage('Error processing label printing.');
    }
    setTimeout(() => {
      setFeedbackVisible(false);
    }, 1500);
  };

  const actionBodyTemplate = (rowData) => {
    return (
      <div>
        <Button
          label="Dar Entrada"
          icon="pi pi-plus"
          className="p-button-rounded p-button-success p-button-text"
          onClick={() => handleDarEntrada(rowData)}
        />
        <Button
          label="Imprimir Etiquetas"
          icon="pi pi-print"
          className="p-button-rounded p-button-info p-button-text"
          onClick={() => handleImprimirEtiquetas(rowData)}
        />
      </div>
    );
  };

  const header = (
    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
      <InputText
        type="search"
        onInput={(e) => setGlobalFilter(e.target.value)}
        placeholder="Search products or scan barcode"
        size="50"
      />
      <i className="pi pi-search" style={{ marginLeft: '0.5rem' }} />
    </div>
  );

  return (
    <Card sx={{ p: 2 }}>
      <h5 style={{ textAlign: 'center', marginBottom: '1rem' }}>Entrada</h5>
      <DataTable
        value={merchandises}
        paginator
        rows={10}
        header={header}
        globalFilter={globalFilter}
        loading={loading}
        responsiveLayout="scroll"
        emptyMessage="No finished products found."
      >
        <Column field="name" header="Product Name" sortable />
        <Column field="reference" header="Reference" sortable />
        <Column
          header="Stock"
          body={(rowData) =>
            rowData.current_quantity !== undefined ? rowData.current_quantity : 0
          }
          sortable
        />
        <Column
          body={actionBodyTemplate}
          header="Actions"
          exportable={false}
          style={{ minWidth: '14rem' }}
        />
      </DataTable>

      {/* Modal para dar entrada */}
      <DarEntradaModal
        visible={entradaModalVisible}
        onHide={() => {
          setEntradaModalVisible(false);
          fetchProducts(); // Atualiza a lista de produtos
        }}
        onConfirm={handleDarEntradaConfirm}
        productReference={selectedProduct ? selectedProduct.reference : ''}
        productName={selectedProduct ? selectedProduct.name : ''}
      />

      {/* Modal para imprimir etiquetas */}
      <ImpEtiquetas
        visible={impEtiquetasVisible}
        onHide={() => {
          setImpEtiquetasVisible(false);
          // opcional: atualizar produtos ou realizar outra ação
        }}
        employees={employees} // Passe a lista de empregados conforme disponível
        onPrint={handlePrintLabels}
      />

      {/* Modal de feedback */}
      <FeedbackModal visible={feedbackVisible}>
        {feedbackStatus === 'loading' && (
          <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
            <Hourglass height="50" width="50" color="#000" ariaLabel="loading" />
            <p>{feedbackMessage}</p>
          </div>
        )}
        {feedbackStatus === 'success' && (
          <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
            <CheckCircleIcon style={{ fontSize: 50, color: 'green' }} />
            <p>{feedbackMessage}</p>
          </div>
        )}
        {feedbackStatus === 'error' && (
          <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
            <p style={{ color: 'red' }}>{feedbackMessage}</p>
          </div>
        )}
      </FeedbackModal>
    </Card>
  );
};

export default Entrada;
